var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon28(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(-1418 -3910)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1418 3910)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_film_reel",
    d: "M14.347,2a12.347,12.347,0,1,0,9.877,19.721v4.972h2.469V14.347A12.365,12.365,0,0,0,14.347,2Zm0,2.469a9.877,9.877,0,1,1-9.877,9.877A9.859,9.859,0,0,1,14.347,4.469Zm0,1.235a2.469,2.469,0,1,0,2.469,2.469A2.469,2.469,0,0,0,14.347,5.7ZM8.173,11.877a2.469,2.469,0,1,0,2.469,2.469A2.469,2.469,0,0,0,8.173,11.877Zm12.347,0a2.469,2.469,0,1,0,2.469,2.469A2.469,2.469,0,0,0,20.52,11.877Zm-6.173,1.235a1.235,1.235,0,1,0,1.235,1.235A1.235,1.235,0,0,0,14.347,13.112Zm0,4.939a2.469,2.469,0,1,0,2.469,2.469A2.469,2.469,0,0,0,14.347,18.051Z",
    transform: "translate(1434 3926)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon28);
export default __webpack_public_path__ + "static/media/facilityIcon28.3b8d4496ade071461f5ba35986818445.svg";
export { ForwardRef as ReactComponent };